import css from './SeloDoTempo.module.css';

interface PropsSeloDoTempo {
  /** "há 12 min", "vence em 4 min", "atrasou 28 min" (textoDoRelogio, core). */
  texto: string;
  /** neutro: dentro do prazo · alerta: vence logo · erro: atrasou. O texto já diz, a cor reforça. */
  tom: 'neutro' | 'alerta' | 'erro';
  /** Linha de baixo ("pedido 18:33"). */
  detalhe?: string;
  className?: string;
}

/** O tempo do pedido contra o prazo da loja, na primeira coluna da lista. */
export function SeloDoTempo({ texto, tom, detalhe, className }: PropsSeloDoTempo) {
  return (
    <span className={[css.selo, className].filter(Boolean).join(' ')}>
      <b className={`${css.tempo} ${css[tom]}`}>{texto}</b>
      {detalhe && <span className={css.detalhe}>{detalhe}</span>}
    </span>
  );
}
